import { defineSagaForService } from '@repo/core'
import {
  bankingProductLoanReceiptsDownloadConfig,
  serviceConfig as bankingProductLoanReceiptsServiceConfig,
} from './bankingProductLoanReceipts'
import {
  bankingProductMovementsDownloadConfig,
  serviceConfig as bankingProductMovementsServiceConfig,
} from './bankingProductMovements'
import {
  loadProductOperationsByFilters,
  serviceConfig as operationsServiceConfig,
  productOperationsDownloadConfig,
} from './operations'

export const serviceConfig = defineSagaForService({
  ...operationsServiceConfig,
  ...bankingProductMovementsServiceConfig,
  ...bankingProductLoanReceiptsServiceConfig,
})

export {
  bankingProductLoanReceiptsDownloadConfig,
  bankingProductMovementsDownloadConfig,
  loadProductOperationsByFilters,
  productOperationsDownloadConfig,
}
